import { type DocumentPageRange } from './types'

export function hasNewDocumentPageRanges(documentPageRanges: DocumentPageRange[]) {
  return documentPageRanges.some((documentPageRange) =>
    documentPageRange.documentId.startsWith('new'),
  )
}
